import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
// import AddCarnivalPopup from "./addCarnivalPopup";
import AddHelpdeskPopup from "./addHelpdeskPopup";

const HelpdeskListing = ({
  carnivalList = null, 
  getHelpdeskList = null,
  match,
  history
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentCarnivalStatus, setCurrentcarnivalStatus] = useState('');
  const [carnivalId, setCarnivalId] = useState('');
  const [changeStatus, setChangeStatus] = useState(false);
  const [projectId, setProjectId] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);


  const Headers = [
    'Project No.',
    'Name',
    // 'URL',
    // 'QR',
    'Start Date',
    'End Date',
    'Status',
    'Actions',
  ];

  useEffect(() => {
    if (getHelpdeskList !== null)
      (async () => {
        setIsLoading(true);
        await getHelpdeskList();
        setIsLoading(false);
      })();
  }, [getHelpdeskList]);

  useEffect(() => {
    const tableData = [
      'id',
      'infra_id',
      'name',
      // 'carnival_link',
      // 'qr_link',
      'start_date',
      'end_date',
      'status',
    ];
    const data =
      carnivalList?.resultSets?.length &&
      carnivalList.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ( 
            (key !== 'carnival_link' && key !== 'qr_link') 
            ? { [key]: element[key] }
            : (key === 'carnival_link' && element['carnival_link'] != '') ? {[key]: <a href={element[key]} target="_blank">URL</a>} : (key === 'qr_link' && element['qr_link'] != '') ? {[key]: <a href={element[key]} target="_blank">QR</a>} : {[key]: 'Not Available'})),

            (element['status'] === 'Active') ?
            {
              Action:
                [{
                  name: 'View Details',
                  link: `${baseUrl}/brand-activation/helpdesk/details`,
                },
                {
                  name: 'Update Details',
                  link: `${baseUrl}/brand-activation/helpdesk/update`,
                },
                {
                  name: 'Create duplicate',
                  link: `${baseUrl}/brand-activation/helpdesk/create-duplicate`,
                },
                {
                  name: 'Change Status',
                  rowData: element,
                }
              ]
            }
            :(element['status'] === 'Hold') ?
            {
              Action:
                [{
                  name: 'View Details',
                  link: `${baseUrl}/brand-activation/helpdesk/details`,
                },
                /* {
                  name: 'Update Details',
                  link: `${baseUrl}/brand-activation/carnival/update`,
                }, */
                {
                  name: 'Change Status',
                  rowData: element,
                }
              ]
            }:(element['status'] === 'Inactive') ?
            {
              Action:
                [{
                  name: 'View Details',
                  link: `${baseUrl}/brand-activation/helpdesk/details`,
                }
              ]
            }:{
              Action:
                [{
                  name: 'View Details',
                  link: `${baseUrl}/brand-activation/helpdesk/details`,
                },
                {
                  name: 'Create duplicate',
                  link: `${baseUrl}/brand-activation/helpdesk/create-duplicate`,
                }
              ]
            }
        )
      );
      // console.log(tableData);
    if (carnivalList?.resultSets?.length && data) {
      setListData(data);
      setPageCount(Math.ceil(carnivalList.total / carnivalList.per_page));
    } else {
      setListData([]);
    }
  }, [carnivalList, baseUrl]);

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setPageNumber(val.selected + 1);
    setIsLoading(true);
    await getHelpdeskList(filter, val.selected + 1);
    setIsLoading(false);
  };

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    // console.log(filterData);return;
    setIsLoading(true);
    setFilterData(filterData);
    await getHelpdeskList(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };
  

  const headerBtns = () => {
    return (
      <Fragment>
        <Link
          to={{
            pathname: `${baseUrl}/brand-activation/add-helpdesk`,
            query: { noOfCamp: carnivalList?.resultSets?.length },
          }}
          className="btn btn-primary d-md-inline-block"
        >
          {localization.scheduleHelpdesk}
          <img src={Images?.ArrowRight} alt="" />
        </Link>
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent filter-btn-dir filters_direction filters-section"
        >
          <img src={Images?.Filter} alt="" />
          <b className="site_filters" style={{width:"max-content"}}>
          {localization.showFilters}
          </b>
        </Button>
      </Fragment>
    );
  };

  return (
    <Layout
      title={localization.helpdeskListing}
      Buttons={headerBtns}
      isGoback
      isLoading={isLoading}
      linkFlag
      linkUrl={`${baseUrl}/brand-activation/sites-listing`}
    >
      <TableSection
        data={listData}
        headers={Headers}
        detailList={carnivalList?.resultSets}
        isId={false}
        pageCount={pageCount}
        onPageChange={onPageChange}
        srNo={carnivalList?.from}
        setChangeStatus={setChangeStatus}
        setCarnivalId={setCarnivalId}
        setCurrentcarnivalStatus={setCurrentcarnivalStatus}
        setProjectId={setProjectId}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
      />

      {changeStatus && <AddHelpdeskPopup
        changeStatus={changeStatus}
        onClosePopup={() => setChangeStatus(false)}
        currentCarnivalStatus={currentCarnivalStatus}
        carnivalId={carnivalId}
        projectId={projectId}
        startDate={startDate}
        endDate={endDate}
        history={history}
        pageNumber={pageNumber}
        getHelpdeskList={getHelpdeskList}
      />}

      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        carnivalFilters={true}
        // listFilterData={siteFilters?.site_types ? siteFilters : null}
        // siteFilters
      />
    </Layout>
  );
};

HelpdeskListing.propTypes = {
  carnivalList: PropTypes.any,
  getHelpdeskList: PropTypes.func,
  match: PropTypes.any,
};

export default HelpdeskListing;
